import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../../../../SidebarItem";

import {ReactComponent as MessageQuestionIcon} from "assets/img/message-question.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";

import {SidebarContext} from "../../../../../../../../../SidebarContext";

function SavItem(props) {
    const {currentMemberAuthorizations, isUserAdmin} = useContext(SidebarContext);

    if (
        !isUserAdmin
        && !hasAuthorization(currentMemberAuthorizations, Authorizations.OTHER_HELPDESK_MERCHAND)
        && !hasAuthorization(currentMemberAuthorizations, Authorizations.OTHER_HELPDESK_CLIENT)
    ) {
        return null
    }

    return (
        <SidebarItem
            isTopLevel={true}
            icon={<MessageQuestionIcon />}
            onClick={() => window.open('/centredaide.html', '_blank')}
        >
            <FormattedMessage id={"sidebar.item.SAV"} />
        </SidebarItem>
    );
}

export default SavItem;
